import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Title = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.primary.dark};
`;

export const HeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Box)`
  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const FolderType = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const FolderTypeTitle = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.15px;
`;

export const Users = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0px;
  gap: 15px;

  width: 100%;
  height: 62px;

  border-bottom: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const SelectedAllBtn = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
  height: 42px;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 5px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const TextBtn = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const AmountSelectedUsers = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;
